import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    /* ********************************************** */
    
    container: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(6),
    },

    /* ********************************************** */

    warenkorb: {
      display: 'grid',
      gap: theme.spacing(4),

      gridTemplateColumns: '1fr',

      [theme.breakpoints.up(955)]: {
        gridTemplateColumns: '1fr max-content',
      },

    },

    /* ********************************************** */

    zusammenfassung: {
      [theme.breakpoints.up(650)]: {
        width: 365,
        marginLeft: 'auto',
      }
    },

    kasseButton: {
      marginTop: theme.spacing(2),
      [theme.breakpoints.down('md')]: { 
        marginTop: theme.spacing(4),
      },
    },

    /* ********************************************** */

    warenkorbLehr: {
      alignItems: 'center',
      background: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: '0 18px 46px rgba(47, 45, 39, 0.08)',
      display: 'grid',
      justifyItems: 'center',
      margin: theme.spacing(3, 'auto', 0),
      maxWidth: 760,
      padding: theme.spacing(6, 5),
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(4, 2.5),
      },
    },

    emptyCartIcon: {
      alignItems: 'center',
      background: 'rgba(0, 0, 0, 0.04)',
      borderRadius: '50%',
      display: 'inline-flex',
      height: 76,
      justifyContent: 'center',
      marginBottom: theme.spacing(2),
      width: 76,
      '& .MuiSvgIcon-root': {
        fontSize: 38,
      },
    },

    emptyCartEyebrow: {
      color: theme.palette.text.secondary,
      fontWeight: 800,
      letterSpacing: 0,
      marginBottom: theme.spacing(.5),
      textTransform: 'uppercase',
    },

    emptyCartText: {
      color: theme.palette.text.secondary,
      margin: theme.spacing(1, 'auto', 0),
      maxWidth: 520,
    },

    emptyCartActions: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(1.5),
      justifyContent: 'center',
      marginTop: theme.spacing(3),
      '& a': {
        textDecoration: 'none',
      },
      [theme.breakpoints.down('sm')]: {
        '& .MuiButton-root': {
          width: '100%',
        },
        flexDirection: 'column',
        width: '100%',
      },
    },

    emptyCartHelp: {
      borderTop: `1px solid ${theme.palette.divider}`,
      color: theme.palette.text.secondary,
      marginTop: theme.spacing(3.5),
      paddingTop: theme.spacing(2),
      width: '100%',
    },

    /* ********************************************** */

  })
)

export default useStyles
